module.exports = __webpack_public_path__ + "img/Menu-09.9f398ce9.webp";